import { FC, useEffect, useState } from 'react'
import { Checkbox, Flex, Text } from '@chakra-ui/react'
import { Choice } from '../../state/interfaces'

interface DefaultCheckboxProps {
  choice: Choice
  isChecked?: boolean
  onChange?: (value: string, checked: boolean) => void
  style?: Record<string, any>
}

export const DefaultCheckbox: FC<DefaultCheckboxProps> = ({ choice: { label, value }, isChecked, ...props }) => {
  const [checked, setChecked] = useState<boolean>(false)

  useEffect(() => {
    if (isChecked) setChecked(isChecked)
  }, [isChecked])

  const toggleChecked = () => {
    setChecked(!checked)
  }

  const handleChange = () => {
    toggleChecked()
    props.onChange && props.onChange(value, !checked)
  }

  const handleLabelClick = () => {
    handleChange()
  }

  return (
    <Flex alignItems="flex-start" minW={{ base: 120, md: 200 }}>
      <Flex border="1px solid lightgrey" alignItems="center" mt={1} minW={'18px'} zIndex={2}>
        <Checkbox isChecked={checked} onChange={handleChange} value={value} colorScheme="green" zIndex={-1} />
      </Flex>
      <Text ml={4} whiteSpace="normal" onClick={handleLabelClick} cursor="pointer" fontSize={{ base: '14', md: '16' }}>
        {label}
      </Text>
    </Flex>
  )
}
